/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */

import React, { useEffect, useState } from 'react';
import { Text, useToast } from '@chakra-ui/react';
import { TOAST_SETTINGS } from '../../constants';
import { getClients } from '../../redux/action/client.action';
import Dropdown from '../Dropdown';

const CompanyDropdown = function ({
  company,
  setCompany,
  validationObj,
  refresh,
  disabled = false,
  setDefaultValue,
  placeholder,
}) {
  const toast = useToast();
  const [companies, setCompanies] = useState([]);
  const [errorMsg, setErrorMsg] = useState(null);
  const [isValid, setValid] = useState(validationObj?.isvalid || true);

  useEffect(() => {
    let isMounted = true;

    const fetchClients = async () => {
      try {
        const result = await getClients(1000, 1, 'name', 'ASC');

        // Only update state if component is still mounted
        if (!isMounted) return;

        if (result && result.ok) {
          setCompanies(result.data.client_details);
          if (setDefaultValue && result.data.client_details.length > 0) {
            setCompany({
              label: result.data.client_details[0].client_name,
              value: result.data.client_details[0].client_id,
              is_restricted: result.data.client_details[0].is_restricted,
              comment_restricted: result.data.client_details[0].comment_restricted,
              weekday_start: result.data.client_details[0].weekday_start,
              total_assignment_pay: result.data.client_details[0].total_assignment_pay,
            });
          }
        } else {
          toast({
            ...TOAST_SETTINGS.SETTINGS,
            status: TOAST_SETTINGS.ERROR,
            title: result.error,
          });
        }
      } catch (error) {
        // Only show error if component is still mounted
        if (isMounted) {
          toast({
            ...TOAST_SETTINGS.SETTINGS,
            status: TOAST_SETTINGS.ERROR,
            title: 'Failed to fetch clients',
          });
        }
      }
    };

    fetchClients();

    // Cleanup function to prevent state updates on unmounted component
    return () => {
      isMounted = false;
    };
  }, []);
  useEffect(() => {
    if (validationObj && !validationObj.isvalid) {
      setErrorMsg(validationObj.errorMessage);
      setValid(validationObj.isvalid);
    }
  }, [refresh]);
  const setCompanyData = (e) => {
    const client_data = companies.find((o) => {
      if (o.client_name === e.label) {
        return o;
      }
    });
    setErrorMsg(null);
    setValid(true);
    setCompany({
      ...e,
      is_restricted: client_data.is_restricted,
      comment_restricted: client_data.comment_restricted,
      weekday_start: client_data.weekday_start,
      total_assignment_pay: client_data.total_assignment_pay,
    });
  };
  return (
    <>
      <Dropdown
        label={`Client${validationObj?.required ? '*' : ''}`}
        onSelect={setCompanyData}
        options={companies.map((comp) => {
          return { label: comp.client_name, value: comp.client_id };
        })}
        value={company}
        placeholder={placeholder || 'All Clients'}
        isError={!isValid}
        disabled={disabled}
      />
      <Text visibility={isValid ? 'hidden' : 'visible'} color="main.error" mb="2px" fontSize="11px">
        {errorMsg || 'Error !'}
      </Text>
    </>
  );
};

export default CompanyDropdown;
